<template>
  <div class="modal-window large split active">
    <div class="grid-x split">
      <div class="cell large-6 flex-column">
        <div class="modal-window-header gray">
          <div class="modal-window-heading">
            <h3 class="icon-heading small">
              <span class="icon"><svg width="16px" height="16px" viewBox="0 0 16 16"><use xlink:href="/static/sprites.svg#button-glyph-print"></use></svg></span>
              <span class="icon-heading-title">
                <span class="title">
                  {{invoiceTitle}} #{{invoiceNumber}}
                </span>
              </span>
            </h3>
          </div>
        </div>
        <div class="modal-window-body">
          <h2 v-if="!bilag.Bilagsnr">Dette bilaget har ikke et bilagsnr.</h2>
        </div>
        <div v-if="bilag.Bilagsnr" class="modal-window-body" >
          <img v-if="barcodeSource" alt="Strekode" :src="barcodeSource" />
        </div>
        <div class="modal-window-footer">
          <div class="grid-x">
            <div class="cell align-right">
              <a v-if="!$store.getters.isFormLoading" href="javascript:;" @click="closeButtonClick()" class="button primary transparent large modal-close show-for-medium">Avbryt</a>
              <a v-else href="javascript:;" class="button primary transparent large modal-close show-for-medium">Avbryt</a>
              <a v-if="showSend24SOButton" href="javascript:;" @click="sendTo24SO()" class="button primary initiate-loading"><span class="button-title">Send til 24SO</span></a>
            </div>
          </div>
        </div>
      </div>

      <div class="cell large-6 flex-column">
        <div class="modal-window-body no-padding">
          <div class="iframe-container pdf">
            <iframe v-if="pdfSource" id="pdfFrame" name="pdfFrame" frameborder="0" marginwidth="0" marginheight="0" scrolling="no" :src="pdfSource + '#view=FitH&toolbar=1'"></iframe>
            <TheEmptyList v-if="!pdfSource && !$store.getters.isFormLoading" :title="'Bilag #' + invoiceNumber + ' PDF'" :message="'Kunne ikke laste inn bilag pdf'" :large="false" :icon="'button-glyph-contract'"/>
            <TheLoader :active="!pdfSource && $store.getters.isFormLoading"/>
          </div>
        </div>
      </div>
    </div>

    <a v-if="!pdfSource" href="javascript:;" class="modal-close modal-window-close-button" @click="closeButtonClick()">
      <span>Lukk</span>
      <svg width="16px" height="16px" viewBox="0 0 16 16"><use xlink:href="/static/sprites.svg#button-glyph-close"></use></svg>
    </a>
  </div>
</template>

<script>
import KundeService from '@/services/KundeService'
import BilagService from '@/services/BilagService'

export default {
  name: 'BilagPdfModal',
  props: {
    bilag: {
      type: Object,
      required: true
    }
  },
  data () {
    return {
      pdfSource: false,
      barcodeSource: false,
      showSend24SOButton: true
    }
  },
  computed: {
    invoiceTitle: function () {
      return this.bilag.Bilagstype === 'F' ? 'Faktura' : 'Kreditnota'
    },
    invoiceNumber: function () {
      return this.bilag.twentyfourseven_invoice_id && this.bilag.Dato > '2019-12-31'
        ? this.bilag.twentyfourseven_invoice_id
        : this.bilag.Bilagsnr
    }
  },
  created () {
    this.setFormLoading(true)
    this.fetch()
    this.showSend24SOButton = ((!this.bilag.twentyfourseven_id && !this.bilag.twentyfourseven_invoice_id) && (this.hasAccess('admin') || this.hasAccess('accounting') || this.hasAccess('management')))
  },
  mounted () {
    window.jQuery('.modal-window-body').attr('tabindex', -1).css({outline: 'none'}).focus()
  },
  methods: {
    closeButtonClick: function () {
      if (!this.$store.getters.isFormProcessing) {
        this.$emit('close')
      }
    },
    sendTo24SO: function () {
      this.setFormLoading(true)
      const post = { PaymentMethod: 'nets' }
      BilagService.finalize(this.bilag.Bilagsid, post)
        .then((response) => {
          this.showSend24SOButton = false
          this.$helpers.showSuccessAlert('Faktura sendt til 24SO')
        })
        .catch((error) => {
          console.log('Error')
          console.log(error)
          this.$helpers.showErrorAlert('Feil', 'Feil ved sending av faktura til 24SO')
        })
        .then(() => {
          this.setFormLoading(false)
        })
    },
    fetch: function () {
      KundeService.getKundeBilagPdf(this.bilag.Bilagsid)
        .then((response) => {
          let url = process.env.VUE_APP_AVANTI_API_URL + response.data

          this.pdfSource = url
        })
        .catch((error) => {
          console.log('Error')
          console.log(error)
          this.$helpers.showErrorAlert('Feil', 'Kunne ikke opprette PDF')
        })
        .then(() => {
          this.setFormLoading(false)
        })
      KundeService.getKundeBilagStrekkode(this.bilag.Bilagsid)
        .then((response) => {
          if (response.data) {
            let url = process.env.VUE_APP_AVANTI_API_URL + response.data
            this.barcodeSource = url
          }
        })
        .catch((error) => {
          console.log('Error')
          console.log(error)
          this.$helpers.showErrorAlert('Feil', 'Kunne ikke finne strekoden')
        })
        .then(() => {
          this.setFormLoading(false)
        })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Admin/BilagPdfModal.vue